// Structured error type the parser throws when input is malformed enough
// that we can't recover. Lives in its own file so v3 entity parsers can
// import it without pulling in the dispatch entry point (which would
// create circular import cycles).
export class ArchitectureParseError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "ArchitectureParseError";
  }
}
